import { useState } from "react";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { joinWaitlist } from "@/lib/api";

export const WaitlistForm = ({ source = "hero", id = "hero" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const res = await joinWaitlist(email, source);
      setState("done");
      toast.success(
        res.already_joined
          ? "You're already on the list — we'll email you at launch."
          : "You're in! Your 5 free recordings are reserved."
      );
    } catch (err) {
      setState("idle");
      toast.error("Please enter a valid email address.");
    }
  };

  if (state === "done") {
    return (
      <div data-testid={`${id}-waitlist-success`} className="flex items-center gap-3 rounded-full border border-cyan/40 bg-cyan/10 px-5 py-4 text-sm">
        <Check className="h-5 w-5 text-cyan" />
        <span><strong>{email}</strong> is on the list. 5 free recordings reserved.</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${id}-waitlist-form`} className="flex w-full max-w-lg flex-col gap-3 sm:flex-row sm:rounded-full sm:border sm:border-white/10 sm:bg-white/5 sm:p-1.5">
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@university.edu"
        aria-label="Email address"
        data-testid={`${id}-waitlist-email-input`}
        className="h-12 rounded-full border-white/10 bg-white/5 px-5 text-base placeholder:text-muted-foreground focus-visible:ring-cyan sm:border-0 sm:bg-transparent"
      />
      <button
        type="submit"
        disabled={state === "loading"}
        data-testid={`${id}-waitlist-submit-button`}
        className="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-full bg-cyan px-6 font-semibold text-black transition-shadow duration-300 hover:shadow-[0_0_24px_hsl(var(--primary)/0.6)] disabled:opacity-60"
      >
        {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Get 5 free recordings
        <ArrowRight className="h-4 w-4" />
      </button>
    </form>
  );
};
